<template>
    <section
        :style="commonConfigStyles"
        class="o-sms-qr-otg"
    >
        <div class="sms-qr-container">
            <div
                ref="qr"
                class="sms-qr"
            ></div>
        </div>
        <div class="sms-qr-main-container">
            <span class="sms-qr-title">
                {{ title }}
            </span>
            <span class="sms-qr-instruction">
                {{ instructionMessage }}
            </span>
            <AButtonOtg
                :title="$t('ui.send-sms')"
                theme="white"
                class="sms-qr-button"
                @onClick="onOpenSmsModal"
            />
        </div>
    </section>
</template>

<script>
import {
    mapState,
    mapGetters
} from "vuex";
import qrcode from "qrcode-generator";

import AButtonOtg from '../../atoms/a-button-otg';

import { EVENTS } from "../../../utils/constants/bus-events-constants";

export default {
    name: 'OSmsQrOtg',
    components: {
        AButtonOtg
    },
    props: {
        itemId: {
            type: Number,
            require: true
        },
        view: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapState({
            mapId: state => state.map.id,
            activeLocale: state => state.activeLocale,
        }),
        ...mapGetters([
            't',
            'getObject',
            'getTerminalId',
            'getMapConfigProp'
        ]),
        item() {
            return this.getObject(this.itemId);
        },
        itemName() {
            return this.t(this.item, 'name') || '';
        },
        type() {
            return this.item.type === 'tenant' ? 'care' : 'service';
        },
        title() {
            return this.$t('ui.get-directions-on-phone') || '';
        },
        instructionMessage() {
            return this.$t('ui.way.scan_qr') || '';
        },
        commonConfigStyles() {
            return this.getMapConfigProp('components.OSmsQrOtg.styles') || null;
        }
    },
    mounted() {
        this.generateCode();
    },
    methods: {
        onOpenSmsModal() {
            const params = {
                itemId: this.itemId,
                itemName: this.itemName,
                terminalId: this.getTerminalId
            };

            this.$bus.$emit(EVENTS.MODALS.INIT_SMS_MODAL_OTG, params);
        },
        generateCode() {
            const typeNumber = 0;
            const errorCorrectionLevel = 'L';
            const terminalId =  this.getTerminalId;
            const qr = qrcode(typeNumber, errorCorrectionLevel);
            const origin = location.origin.includes('staging') ? 'staging.mvgcloud.com' : 'app2.mvgcloud.com';
            const url = `https://${origin}/map-${this.mapId}/integrations/web/path?mv=GuideView&mTo=${this.itemId}&mvGuideMode=fast&mFrom=${terminalId}`

            qr.addData(url);
            qr.make();
            this.$refs.qr.innerHTML = qr.createSvgTag({ margin: 0});

        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />